export class Scan {
  guid: string;
  name: string;
  numPages: number;
  splitMode: ScanSplitMode;
  splits: Split[];
  pagesDeleted: Page[];
}

export enum ScanSplitMode {
  None = 'none',
  Barcode = 'barcode',
  BarcodeWithout = 'barcodewithout',
  QRCode = 'qrcode',
  QRCodeWithout = 'qrcodewithout',
}

export class Split {
  guid: string;
  name: string;
  lock: boolean;
  mainCode: string;
  externalData: JSON;
  pages: Page[];
}

export class Page {
  guid: string;
  rotation: number;
  url: string;
  codes: [
    {
      text: string;
      format: string;
    },
  ];
  originPageNumber: number;
}

export class DetailSplit {
  title?: string;
  description?: string;
  titleButton?: string;
}
